module.exports = __webpack_public_path__ + "assets/img/4_118.82727d72.jpg";